import { networkingHostnameQueryOptions } from '@goshippo/print';

import { STABLE_QZ_QUERY_SETTINGS } from './qzQuery.const';

export const HOSTNAME_QUERY_OPTIONS = {
  ...networkingHostnameQueryOptions(),
  ...STABLE_QZ_QUERY_SETTINGS,
};
